import { ProviderType } from '../api/types';
import { CareModel } from '../models/user';

const PROVIDER_LABEL_BY_STABLE_STRING: Record<string, string> = {
  book_with_doctor: 'Provider',
  book_with_coach: 'Coach',
  book_with_pharmacist: 'Pharmacist',
  book_with_rd: 'Dietitian',
  book_with_social_worker: 'Social worker',
  book_with_np: 'Nurse practitioner',
};

const PROVIDER_TYPE_BY_STABLE_STRING: Record<string, ProviderType> = {
  book_with_doctor: ProviderType.Provider,
  book_with_coach: ProviderType.Coach,
  book_with_pharmacist: ProviderType.Pharmacist,
  book_with_rd: ProviderType.Dietitian,
};

export const getVisitBlockProviderLabel = (
  stableString?: string | null,
  careModel?: CareModel | null
): string => {
  if (stableString === 'book_welcome_visit') {
    return careModel === CareModel.Collaborative
      ? 'Initial Consultation'
      : 'Initial Coach Call';
  }

  return PROVIDER_LABEL_BY_STABLE_STRING[stableString ?? ''] ?? 'Unknown';
};

export const getVisitBlockProviderType = (
  stableString?: string | null,
  careModel?: CareModel | null
): ProviderType | undefined => {
  if (stableString === 'book_welcome_visit') {
    return careModel === CareModel.Collaborative
      ? ProviderType.Provider
      : ProviderType.Coach;
  }

  return PROVIDER_TYPE_BY_STABLE_STRING[stableString ?? ''];
};
